import axiosInstance from '../axiosConfig';
import React, { useState } from "react";
import Auth from '../services/AuthService.js';
import { Mail, Lock, Eye, EyeOff } from "lucide-react";

const Login = () => {
    const [senhaVisivel, setSenhaVisivel] = useState(false);
    const [formData, setFormData] = useState({ email: "", senha: "" });
    const [erro, setErro] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setErro("");
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const toggleSenhaVisivel = () => setSenhaVisivel(!senhaVisivel);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.email || !formData.senha) {
            setErro("Todos os campos são obrigatórios!");
            return;
        }

        try {
            setLoading(true);
            const response = await axiosInstance.post("Auth/admin/token", formData);
            if (response.status === 200) {
                Auth.login(response.data);
            }
        } catch (error) {
            if (error.response) {
                setErro(error.response.data.message || "Erro ao autenticar. Verifique suas credenciais.");
            } else if (error.request) {
                setErro("Erro de conexão. Verifique sua internet ou tente novamente mais tarde.");
            } else {
                setErro("Erro inesperado. Por favor, tente novamente.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-100 via-white to-indigo-200 px-5">
            <div className="bg-white/80 backdrop-blur-md p-10 rounded-2xl shadow-xl w-full max-w-md border border-gray-200">
                <h2 className="text-3xl font-bold text-center text-gray-800 mb-2">Bem-vindo</h2>
                <p className="text-center text-gray-600 mb-6">Faça login para continuar</p>

                <form onSubmit={handleSubmit} noValidate>
                    {/* Email */}
                    <div className="mb-5">
                        <label className="block text-gray-700 font-medium mb-1">Email</label>
                        <div className="relative">
                            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                            <input
                                type="email"
                                name="email"
                                placeholder="Digite seu email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`pl-10 w-full px-4 py-3 border rounded-lg text-gray-700 focus:outline-none focus:ring-2 ${erro && !formData.email ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-indigo-500"}`}
                                required
                            />
                        </div>
                    </div>

                    {/* Senha */}
                    <div className="mb-5">
                        <label className="block text-gray-700 font-medium mb-1">Senha</label>
                        <div className="relative">
                            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                            <input
                                type={senhaVisivel ? "text" : "password"}
                                name="senha"
                                placeholder="Digite sua senha"
                                value={formData.senha}
                                onChange={handleChange}
                                className={`pl-10 pr-10 w-full px-4 py-3 border rounded-lg text-gray-700 focus:outline-none focus:ring-2 ${erro && !formData.senha ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-indigo-500"}`}
                                required
                            />
                            <button
                                type="button"
                                onClick={toggleSenhaVisivel}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-indigo-500"
                            >
                                {senhaVisivel ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </div>

                    {/* Erro */}
                    {erro && <p className="text-red-500 text-sm text-center mb-4">{erro}</p>}

                    {/* Botão */}
                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full font-semibold py-3 px-4 rounded-lg shadow-md transition-all duration-200 ${
                            loading
                                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                : "bg-indigo-500 text-white hover:bg-indigo-600 hover:shadow-lg"
                        }`}
                    >
                        {loading ? "Entrando..." : "Entrar"}
                    </button>
                </form>

                {/* Suporte */}
                <p className="text-center text-sm text-gray-400 mt-6">
                    Problemas no login?{" "}
                    <a
                        href="https://wa.me/5516997415602"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Abrir conversa no WhatsApp"
                        className="text-indigo-500 hover:underline"
                    >
                        Fale com o suporte
                    </a>
                </p>
            </div>
        </div>
    );
};

export default Login;